import { CURRENCY } from "./types/formConstants";
export const useCurrency = () => {
  const getCurrencyFormat = (value: number, currency: string) => {
    const format =
      currency === CURRENCY.crc
        ? Intl.NumberFormat("es-CR", {
            style: "currency",
            currency: "CRC",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })
        : Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          });

    const fraction =
      currency === CURRENCY.crc
        ? Intl.NumberFormat("es-CR", {
            style: "currency",
            currency: "CRC",
            maximumFractionDigits: 2,
          })
        : Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          });
          
    return value % 1 !== 0 ? fraction.format(value) : format.format(value);
  };

  return {
    getCurrencyFormat,
  };
};
